import { SET_BRIDGE_HANDOFF } from './../../mutation-types';

export default {
  [SET_BRIDGE_HANDOFF](state, payload) {
    state.state = payload;
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/bridgeHandoff/mutations.js